// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "css/" + {"136":"organisation","464":"search","587":"community","771":"researchGroup","903":"researcher"}[chunkId] + "." + {"136":"21f0a577","464":"21f0a577","587":"21f0a577","771":"21f0a577","903":"473e15d9"}[chunkId] + ".css";
};